import { useState } from "react";
import FinancialHealth from "./FinancialHealth";
import HowItWorks from "./HowItWorks";
import Overview from "./Overview";

const SLIDES = [Overview, HowItWorks, FinancialHealth];

const Intro = ({ onCancel, embedded, goToNextStep }) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  const goToNext = () => {
    if (currentSlideIndex >= SLIDES.length - 1) {
      return goToNextStep();
    }

    return setCurrentSlideIndex((s) => s + 1);
  };

  const Slide = SLIDES[currentSlideIndex];

  return (
    <Slide onCancel={onCancel} onContinue={goToNext} embedded={embedded} />
  );
};

export default Intro;
